<div class="btn-group"
     dropdown
     placement="bottom right"
     #dropdown="bs-dropdown">
    <button
        id="header-menu"
        dropdownToggle
        appTrackClickButton
        type="button"
        class="dropdown-menu-trigger"
        aria-controls="dropdown-header-menu"
    >
        <img [src]="iconLink" alt="icon-link">
    </button>
    <ul id="dropdown-header-menu" appStopClickPropagation *dropdownMenu class="dropdown-menu dropdown-menu-right"
        role="menu" tabindex="-1" aria-labelledby="header-menu">
        <ui-link-items [dropdown]="dropdown"></ui-link-items>
    </ul>
</div>
